<template>
  <a class="cursor-pointer" v-if="$route.name !== 'empresas-id'" @click="toggleChat($event)">
    <div class="fixed right-0 z-50 bottom-0 mb-20 mr-10">
      <div class="w-20 h-20 rounded-full flex justify-center items-center bg-[#03D342]">
        <img src="@/assets/img/home/help/whatsapp.svg" loading="lazy" alt="Ícone do WhatsApp" />
      </div>
    </div>
  </a>

  <div v-if="isFormActive('floating_icon')" class="fixed bottom-44 md:right-16 h-fit z-50">
    <WhatsAppForm @close="closeForm" />
  </div>
</template>

<script>
import WhatsAppForm from "@/components/WhatsAppForm.vue";
import { useWhatsAppChat } from "@/composables/useWhatsAppChat";
import { useWhatsAppFormManager } from "@/composables/useWhatsAppFormManager";

export default {
  components: {
    WhatsAppForm,
  },
  setup() {
    const whatsApp = useWhatsAppChat();
    const formManager = useWhatsAppFormManager();

    const toggleChat = (event) => {
      // Previne propagar o evento para o documento
      if (event) {
        event.stopPropagation();
        event.preventDefault();
      }
      
      if (formManager.isFormActive('floating_icon')) {
        formManager.closeForm();
      } else {
        formManager.openForm('floating_icon');
      }
    };

    return { 
      ...whatsApp,
      isFormActive: formManager.isFormActive,
      closeForm: formManager.closeForm,
      toggleChat
    };
  },
};
</script>
